import { render } from "./CertDetailOct2024Page.vue?vue&type=template&id=00df2b9c"
import script from "./CertDetailOct2024Page.vue?vue&type=script&lang=js"
export * from "./CertDetailOct2024Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__